angular.module('cvsApp').factory('commonModel',[function() {	
	'use strict';
	var commonModel = function(){
		var self = this;	
		
		this.setResponse = function(data){
			data = data.replace(/[\n\r\t]+/g,"");		
			self = cvsUtility.xmlToJSON(data);
			
		};
        /**
		 * ITPR020028 - Self Enroll project - SP - 11/27/2017
		 * Added new method to handled JSON response
         * @param data
         */
        this.setJSONResponse = function(data){
            self = data;

		};

		this.setAGPResponse = function(data, agpResponseKey){
			self = {};
            self.response = data[agpResponseKey];

		};
		
		this.setAGPXmlToJsonResponse = function(data, agpResponseKey){
			var jsonData = cvsUtility.xmlToJSON(data.replace(/[\n\r\t]+/g,""));
			self = {};
            self.response = jsonData[agpResponseKey];

        };

		this.getResponse =function (){
			var viewdata ={};
			/**
			 * SP 11/06/2016 - ITPR015400 - Guest Refill
			 * Added logic to handle DBPL success service code.
			 */
	        if(getHeader().statusCode === "0000" || getHeader().statusCode === "DBPL0000"){
	            viewdata = getDetails();           
	        }else if(getHeader().statusCode === "6621" || getHeader().statusCode === "6622"){
	           //send message to parent
				//cvsUtility.genralPostMessage("EMPTY_FRAME",'{isEmpty:true}');
	            viewdata.isViewError = true;
	            viewdata.apiMsg = getHeader();
	        }else{          
	            viewdata.showError = getHeader() ? getHeader() : self.fault.title;
	        }	        
	        return viewdata;			
		};
		
		this.getCommonResponse = function(){
			var response = this.getResponse();
			var selfRes = {};

			selfRes.getResponse = function(){
				return response;
			}

			selfRes.showView = function(){
				if(response.isViewError){	
					return !response.isViewError;
				}
				return true;
			}

			selfRes.getError = function(){
				if(response.showError){	
					return response.showError;
				}
				return "";
			}
			return selfRes;
		};	


		this.showView = function(){
			if(self.viewdata.isViewError){	
				return !self.isViewError;
			}
			return true;
		};

		this.getError = function(){
			if(self.viewdata.showError){	
				return self.viewdata.showError;
			}
			return "";
		};

		var getHeader =function (){
            if(self.hasOwnProperty('validateLinkResponse')){
                return self.validateLinkResponse.header;
            }
			if(self && self.response && self.response.header) {
				return self.response.header;
			}
			return self;
		};

		/**
		 * SP 11/07/2016 - ITPR015400 - Guest Refill
		 * Added getHeader function to read header exposing to other modules
		 */

		this.getHeader =function (){
			if(self.hasOwnProperty('validateLinkResponse')){
                return self.validateLinkResponse.header;
            }
			if(self && self.response && self.response.header) {
				return self.response.header;
			}
			return self;
		};

		var getDetails =function (){
			if(self.hasOwnProperty('response') && self.response.details){
				return self.response.details;
			} else if(self.details && Object.keys(self.details).length) {
				return self.details
			} else if(self.hasOwnProperty('validateLinkResponse') && self.validateLinkResponse.details){
                return self.validateLinkResponse.details;
            }
			else{
				return true;
			}
			
		};
	
	};
	
	return new commonModel();
}]);
